import React, { useCallback } from 'react';
import * as c from '../../ts/const';
import ImgPicture from './img-picture';
import { sendGtag } from '../../ts/modules/sendgtag';
const LatestItem = ({ latestItem }) => {
    const handleClick = useCallback(() => {
        const eventPrams = {
            event_action: 'NEW',
            event_category: c.EVENT_CATEGORY,
            event_label: `[新作]${latestItem.name}`
        };
        sendGtag(eventPrams, c.IS_DEV);
    }, [
        latestItem
    ]);
    return (React.createElement("div", { className: "column-item " },
        React.createElement("div", { className: "column-item-image" },
            React.createElement("a", { href: latestItem.url, target: "_blank", onClick: handleClick },
                React.createElement(ImgPicture, { fileName: `./assets/img/latest-item/${latestItem.image_name}`, alt: latestItem.name, ext: 'jpg' }))),
        React.createElement("div", { className: "column-item-name" },
            React.createElement("a", { href: latestItem.url, target: "_blank", "data-label-hover": "\u516C\u5F0F\u30B5\u30A4\u30C8\u3078", onClick: handleClick }, latestItem.name))));
};
export default LatestItem;
